import React from 'react';
import cx from 'classnames';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '@modules/portableTextBlock';

const ThreeColumnText = ({ textOne, textTwo, textThree, blockConfig }) => {
  return (
    <BlockWrapper
      className={`prose md:prose-lg lg:prose-mt-0 max-w-none grid grid-cols-14`}
      {...blockConfig}>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 col-start-2 col-end-14 text-black'>
        <PortableTextBlock text={textOne} className='col-span-1' />

        <PortableTextBlock text={textTwo} className='col-span-1' />

        <PortableTextBlock text={textThree} className='col-span-1' />
      </div>
    </BlockWrapper>
  );
};

export default ThreeColumnText;
